// extracted by mini-css-extract-plugin
export default {"masterAndCardsColumns":"master-and-cards-container-style_masterAndCardsColumns__BeMBg","container":"master-and-cards-container-style_container__pkRk6"};